import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    column-gap: 5em;
`;

const ServiceItem = styled.div`
    text-align: center;
    width: 13em;
    padding: 1em;
    font-size: 0.9rem;
`;

const ServiceIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1em;
`;

const items = [
    { src: 'van', p: 'Convenient collection options' },
    { src: 'mileage', p: 'Go where you want with unlimited mileage' },
    {
        src: 'insurance',
        p: 'Peace of mind with comprehensive insurance included',
    },
    {
        src: 'transmission',
        p: 'Fully automatic for hassle-free and relaxed driving',
    },
];

function ServiceRow() {
    return (
        <Container>
            {items.map((item) => (
                <ServiceItem>
                    <ServiceIcon>
                        <img
                            src={`/images/homepage/${item.src}_icon_gradient.png`}
                            width="80%"
                            alt=""
                        />
                    </ServiceIcon>
                    <div>
                        <p>{item.p}</p>
                    </div>
                </ServiceItem>
            ))}
        </Container>
    );
}
export default ServiceRow;
